export function KeepProperty(target: any, propertyKey: string) {
	if (!target.constructor.keepProperties) {
	  	target.constructor.keepProperties = [];
	}
	target.constructor.keepProperties.push(propertyKey);
}